import React, { useState } from "react";
import PropTypes from "prop-types";
import Popup from "~/assets/js/components/Popup";
import Radio from "~/assets/js/components/Forms/Radio";
import i18n from "~/assets/js/Helpers/i18n";
import Button from "~/assets/js/components/Button";
import useViewport from "~/assets/js/Helpers/hooks/useViewport";
import { useCartContext } from "~/assets/js/global/cartContext";

import EarlyOnLocationInfo from "./EarlyOnLocationInfo";

const EarlyOnLocationToggle = ({ open, handleClose, deliveryDate }) => {
    const { actions } = useCartContext();
    const { isDesktop } = useViewport();

    const [state, setState] = useState({
        earlyOnLocation: true,
        infoOpen: false,
    });

    const setEarlyOnLocation = (value) => {
        setState({ ...state, earlyOnLocation: value });
    };

    const handleOnSave = async () => {
        await actions.updateEarlyOnLocation(state.earlyOnLocation);
        handleClose();
    };

    const onInfoOpen = () => {
        setState({ ...state, infoOpen: true });
    };

    const closeInfo = () => {
        setState({ ...state, infoOpen: false });
    };

    const earlyOnLocationPopupConfig = {
        title: i18n.t("timeSlotSelect.earlyOnSite.title"),
        open: open,
        subtitle: deliveryDate,
        handleClose: handleClose,
        isInfo: true,
        handleInfo: onInfoOpen,
        position: isDesktop ? "side" : "bottom",
    };

    return (
        <Popup {...earlyOnLocationPopupConfig}>
            <EarlyOnLocationInfo
                open={state.infoOpen}
                handleClose={closeInfo}
            />

            <div className="early-on-location__container">
                <Radio
                    onValueChange={() => {
                        setEarlyOnLocation(true);
                    }}
                    bindName="earlyOnLocation"
                    value={true}
                    customStyles="early-on-location__radio"
                    currentValue={state.earlyOnLocation}
                >
                    <span> {i18n.t("timeSlotSelect.earlyOnSite.yes")}</span>
                </Radio>
                <Radio
                    onValueChange={() => {
                        setEarlyOnLocation(false);
                    }}
                    bindName="earlyOnLocation"
                    value={false}
                    customStyles="early-on-location__radio"
                    currentValue={state.earlyOnLocation}
                >
                    <span> {i18n.t("timeSlotSelect.earlyOnSite.no")}</span>
                </Radio>
            </div>
            <Button
                size="SM"
                customStyle="early-on-location__button"
                onClick={handleOnSave}
                label={i18n.t("timeSlotSelect.earlyOnSite.finished")}
            />
        </Popup>
    );
};

EarlyOnLocationToggle.propTypes = {
    open: PropTypes.bool.isRequired,
    handleClose: PropTypes.func,
    deliveryDate: PropTypes.string,
};

export default EarlyOnLocationToggle;
